module.exports = __webpack_public_path__ + "img/pic_follow_bigsale1@2x.501fc206.png";